export const tertiary = {
    purple: {
        100: '#F7F5FD',
        300: '#EFEDFA',
        500: '#E1DEF6',
        700: '#CAC3EF',
        900: '#AEA1E4',
        1000: '#937CD8',
        main: '#937CD8',
        1100: '#7F5DCA',
        1300: '#6F4BB6',
        1500: '#5D3E99',
        1700: '#4D357D',
    },
    pink: {
        100: '#FFF1F3',
        300: '#FFE3E7',
        500: '#FFCCD5',
        700: '#FF8BA0',
        900: '#FE6E8B',
        1000: '#F83B66',
        main: '#F83B66',
        1100: '#E51952',
        1300: '#C20E44',
        1500: '#A20F40',
        1700: '#8B103D',
    },
    yellow: {
        100: '#FEF8E8',
        300: '#FDFDC4',
        500: '#FCF88C',
        700: '#FBED49',
        900: '#F7DD19',
        1000: '#E7C30B',
        main: '#E7C30B',
        1100: '#C79907',
        1300: '#9F6F09',
        1500: '#835710',
        1700: '#704713',
    },
    litblue: {
        100: '#EFFAFF',
        300: '#DFF4FF',
        500: '#B8EBFF',
        700: '#78DDFF',
        900: '#4AD2FF',
        1000: '#06B6F1',
        main: '#06B6F1',
        1100: '#0092CE',
        1300: '#0075A7',
        1500: '#02628A',
        1700: '#085172',
    },
    orange: {
        100: '#FFF3ED',
        300: '#FFE4D4',
        500: '#FFC5A8',
        700: '#FF9C71',
        900: '#FF7245',
        1000: '#FE4111',
        main: '#FE4111',
        1100: '#EF2707',
        1300: '#C61708',
        1500: '#9D150F',
        1700: '#7E1510',
    },
    turquoise: {
        100: '#E7FFF8',
        300: '#C6FFEB',
        500: '#92FFDE',
        700: '#4DFFD2',
        900: '#00FFBF',
        1000: '#00E8AB',
        main: '#00E8AB',
        1100: '#00BE8E',
        1300: '#009876',
        1500: '#00785F',
        1700: '#00624F',
    },
};
